import React from 'react';
import { string, func } from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import './AmexGDAChefCard.scss';

const AmexGDAChefCard = (
  {
    baseRequestUrl,
    printContent,
    name,
    location,
    descriptionText,
    descriptionImgDesktop,
    descriptionImgMobile,
    venueName,
    venueType,
    venueImg,
    bookNowText,
    bookNowLink,
    noBookNowText,
  }
) => {
  const cardContent = (linkText) => (
    <div className="GDA__Chefcard--venue-container">
      <img src={`${baseRequestUrl}GDAChef/${venueImg}`} alt="" />
      <h4 className="GDA__Chefcard--venue">
        {printContent(venueName, 'venueName')}
      </h4>
      <p className="GDA__Chefcard--type">
        {printContent(venueType, 'venueType')}
      </p>
      <p className="GDA__Chefcard--booknowlink">
        {printContent(linkText, `${linkText}`)}
      </p>
    </div>
  );

  return (
    <>
      <li className="GDA__Chefcard">
        <h3 className="GDA__Chefcard--name">
          {printContent(name, 'name')}
          <span>{location}</span>
        </h3>
        <div className="GDA__Chefcard--description-img-container--desktop">
          <img src={`${baseRequestUrl}GDAChef/${descriptionImgDesktop}`} alt="" />
        </div>
        <div className="GDA__Chefcard--description-img-container--mobile">
          <img src={`${baseRequestUrl}GDAChef/${descriptionImgMobile}`} alt="" />
        </div>
        <div className="GDA__Chefcard--description-container">
          <p className="GDA__Chefcard--description">
            {printContent(descriptionText, 'descriptionText')}
          </p>
        </div>
        {bookNowLink ? (
          <Link
            target="_blank"
            className="GDA__Chefcard--link"
            rel="noopener noreferrer"
            href={bookNowLink}
          >
            {cardContent(bookNowText)}
          </Link>
        ) : (
          <div className="GDA__Chefcard--no-link">
            {cardContent(noBookNowText)}
          </div>
        )}
      </li>
    </>
  );
};

AmexGDAChefCard.propTypes = {
  baseRequestUrl: string.isRequired,
  name: string.isRequired,
  location: string.isRequired,
  descriptionText: string.isRequired,
  descriptionImgDesktop: string.isRequired,
  descriptionImgMobile: string.isRequired,
  venueName: string.isRequired,
  venueType: string.isRequired,
  venueImg: string.isRequired,
  bookNowText: string.isRequired,
  bookNowLink: string,
  noBookNowText: string.isRequired,
  printContent: func.isRequired,
};

AmexGDAChefCard.defaultProps = {
  bookNowLink: '',
};

export default AmexGDAChefCard;
